
<app-header />
<div class="layout-body">
  <app-sidebar role="dealer" />
  <main class="layout-content">
    <router-outlet />
  </main>
</div>
